export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9973.671c8e2a.jpg";